import { render, staticRenderFns } from "./productLazadaPicklist.vue?vue&type=template&id=471b8e17&"
import script from "./productLazadaPicklist.vue?vue&type=script&lang=js&"
export * from "./productLazadaPicklist.vue?vue&type=script&lang=js&"
import style0 from "./productLazadaPicklist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports